import { useState, useEffect } from "react";
import "./MemoryCard.css";

export default function MemoryCard() {
  const cards = ["🍎", "🍌", "🍒", "🍇"];
  
  const [doubled, setDoubled] = useState(() =>
    [...cards, ...cards].sort(() => Math.random() - 0.5)
  );
  const [opened, setOpened] = useState([]);
  const [matched, setMatched] = useState([]);
  const [tries, setTries] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const [disableClick, setDisableClick] = useState(false);

  const handleClick = (index) => {
    if (disableClick || opened.includes(index) || matched.includes(index)) return;

    const newOpened = [...opened, index];
    setOpened(newOpened);

    if (newOpened.length === 2) {
      setDisableClick(true);
      setTries((prev) => prev + 1);

      const [firstIndex, secondIndex] = newOpened;
      const first = doubled[firstIndex];
      const second = doubled[secondIndex];

      if (first === second) {
        setMatched((prev) => [...prev, ...newOpened]);
      }

      setTimeout(() => {
        setOpened([]);
        setDisableClick(false);
      }, 800);
    }
  };

  const resetGame = () => {
    const reshuffled = [...cards, ...cards].sort(() => Math.random() - 0.5);
    setDoubled(reshuffled);
    setOpened([]);
    setMatched([]);
    setTries(0);
    setGameOver(false);
    setDisableClick(false);
  };

  useEffect(() => {
    if (matched.length === doubled.length && doubled.length > 0) {
      setGameOver(true);
    }
  }, [matched, doubled]);

  return (
    <div className="memory-wrapper">
      <h2>Memory Card Game</h2>

      {/* Rules Section */}
      <div className="memory-rules">
        <h3>How to Play:</h3>
        <ul>
          <li>Click on a card to reveal its symbol.</li>
          <li>Try to find the matching pair of the same symbol.</li>
          <li>If the cards match, they stay revealed. Otherwise, they flip back.</li>
          <li>Complete all pairs with the fewest tries!</li>
        </ul>
      </div>

      {/* Stats */}
      <div className="memory-stats">
        <p>Tries: {tries}</p>
        <p>Matched: {matched.length / 2} / {cards.length}</p>
      </div>

      {/* Game Grid */}
      <div className="memory-grid">
        {doubled.map((value, index) => {
          const isOpen = opened.includes(index) || matched.includes(index);
          return (
            <div
              key={index}
              className={`memory-card ${isOpen ? "open" : ""} ${matched.includes(index) ? "matched" : ""}`}
              onClick={() => handleClick(index)}
            >
              <span>{isOpen ? value : "?"}</span>
            </div>
          );
        })}
      </div>

      {/* Game Over */}
      {gameOver && (
        <div className="memory-over">
          <p>🎉 You completed the game in {tries} {tries === 1 ? "try" : "tries"}!</p>
          <button onClick={resetGame}>Restart</button>
        </div>
      )}
    </div>
  );
}
